import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';

import { useActions } from '../../../hooks/useActions';
import { ExtendProductSubscriptionPageParamsType } from '../../../models/types/RoutePath';
import { clearCurrentOrganization } from '../../../store/redux-slices/organizations';
import { organizationNameSelector } from '../../../store/redux-slices/organizations/selectors';
import { clearSubscriptionExtensionSummary } from '../../../store/redux-slices/subscriptions/common';
import { clearTLSubscriptionOverview } from '../../../store/redux-slices/subscriptions/travelLicense';
import { loadOrganization } from '../../../store/saga-slices/organizations';
import { loadTLSubscriptionOverview } from '../../../store/saga-slices/subscriptions/travelLicense';
import { ILoadTLSubscriptionOverviewPayload } from '../../../store/saga-slices/subscriptions/travelLicense/models';

export const useExtendTLSubscriptionPage = () => {
  const { organizationId, subscriptionId } =
    useParams<ExtendProductSubscriptionPageParamsType>();

  const organizationName = useSelector(organizationNameSelector);

  const LoadOrganization = useActions(loadOrganization);
  const LoadSubscriptionOverview = useActions(loadTLSubscriptionOverview);
  const ClearCurrentOrganization = useActions(clearCurrentOrganization);
  const ClearCurrentSubscription = useActions(clearTLSubscriptionOverview);
  const ClearSubscriptionExtensionSummary = useActions(
    clearSubscriptionExtensionSummary,
  );

  useEffect(() => {
    LoadOrganization(organizationId);
    const loadSubscriptionOverviewPayload: ILoadTLSubscriptionOverviewPayload =
      {
        organizationId,
        subscriptionId,
      };
    LoadSubscriptionOverview(loadSubscriptionOverviewPayload);
  }, [
    LoadOrganization,
    LoadSubscriptionOverview,
    organizationId,
    subscriptionId,
  ]);

  useEffect(
    () => () => {
      ClearCurrentOrganization();
      ClearCurrentSubscription();
      ClearSubscriptionExtensionSummary();
    },
    [
      ClearCurrentOrganization,
      ClearCurrentSubscription,
      ClearSubscriptionExtensionSummary,
    ],
  );

  return { organizationName, organizationId, subscriptionId };
};
